var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};

// src/error-codes.ts
var ErrorCodes = {
  BAD_REQUEST: { status: 400 },
  UNAUTHORIZED: { status: 401 },
  FORBIDDEN: { status: 403 },
  NOT_FOUND: { status: 404 },
  METHOD_NOT_SUPPORTED: { status: 405 },
  TIMEOUT: { status: 408 },
  CONFLICT: { status: 409 },
  PRECONDITION_FAILED: { status: 412 },
  PAYLOAD_TOO_LARGE: { status: 413 },
  UNPROCESSABLE_CONTENT: { status: 422 },
  TOO_MANY_REQUESTS: { status: 429 },
  CLIENT_CLOSED_REQUEST: { status: 499 },
  INTERNAL_SERVER_ERROR: { status: 500 },
  EXTERNAL_SERVICE_ERROR: { status: 502 }
};
var ErrorCodeNames = Object.fromEntries(
  Object.keys(ErrorCodes).map((key) => [key, key])
);
function isErrorCode(code) {
  return typeof code === "string" && code in ErrorCodes;
}

// src/app-error.ts
var AppError = class extends Error {
  code;
  statusCode;
  context;
  isOperational;
  constructor({
    code,
    message,
    cause,
    context = {},
    isOperational = true
  }) {
    super(message, { cause });
    this.name = "AppError";
    this.code = code;
    this.statusCode = ErrorCodes[code].status;
    this.context = context;
    this.isOperational = isOperational;
  }
  toJSON() {
    return {
      name: this.name,
      code: this.code,
      statusCode: this.statusCode,
      message: this.message,
      context: this.context,
      isOperational: this.isOperational
    };
  }
};
var ValidationError = class extends AppError {
  constructor(message, context, cause) {
    super({ code: "BAD_REQUEST", message, context, cause });
    this.name = "ValidationError";
  }
};
var NotFoundError = class extends AppError {
  constructor(message, context, cause) {
    super({ code: "NOT_FOUND", message, context, cause });
    this.name = "NotFoundError";
  }
};
var UnauthorizedError = class extends AppError {
  constructor(message, context, cause) {
    super({ code: "UNAUTHORIZED", message, context, cause });
    this.name = "UnauthorizedError";
  }
};
var ForbiddenError = class extends AppError {
  constructor(message, context, cause) {
    super({ code: "FORBIDDEN", message, context, cause });
    this.name = "ForbiddenError";
  }
};
var ConflictError = class extends AppError {
  constructor(message, context, cause) {
    super({ code: "CONFLICT", message, context, cause });
    this.name = "ConflictError";
  }
};
var TimeoutError = class extends AppError {
  constructor(message, context, cause) {
    super({ code: "TIMEOUT", message, context, cause });
    this.name = "TimeoutError";
  }
};
var ExternalServiceError = class extends AppError {
  constructor(message, context, cause) {
    super({
      code: "EXTERNAL_SERVICE_ERROR",
      message,
      context,
      cause,
      isOperational: false
    });
    this.name = "ExternalServiceError";
  }
};

export {
  __decorateClass,
  ErrorCodes,
  ErrorCodeNames,
  isErrorCode,
  AppError,
  ValidationError,
  NotFoundError,
  UnauthorizedError,
  ForbiddenError,
  ConflictError,
  TimeoutError,
  ExternalServiceError
};
//# sourceMappingURL=chunk-IMYT4A3Z.js.map